import { render, staticRenderFns } from "./CompanyInsuranceEdit.vue?vue&type=template&id=04f87a08&scoped=true&"
import script from "./CompanyInsuranceEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyInsuranceEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInsuranceEdit.vue?vue&type=style&index=0&id=04f87a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f87a08",
  null
  
)

export default component.exports